import { ShortFormElementContent } from "./ShortFormElementContent"
import { ShortFormElementPopper } from "./ShortFormElementPopper"
import { ShortFormElementType } from "./ShortFormElementType"

export type ShortFormElement<TValue> = {
  label: string
  value: TValue
  onChange?: (newValue?: TValue) => void
  onSubmit?: (newValue?: TValue) => Promise<void> | void
  type: ShortFormElementType
  content: ShortFormElementContent
  contentRenderOption?: (option: TValue) => JSX.Element
  readonly?: boolean
  addText?: string
  popperProps: ShortFormElementPopper
  formatOption?: (option: TValue) => string
  renderOption?: (option: TValue) => JSX.Element
}
